"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const socket_io_client_1 = require("socket.io-client");
const rest_1 = require("./rest");
const events = __importStar(require("./events"));
const events_1 = require("./events");
let socket;
let currentRoom;
function SocketIOService() {
    socket = (0, socket_io_client_1.io)((0, rest_1.getBaseUrl)());
    console.log("I'm a new instance !");
    socket.on("connect", () => {
        console.log("connect : " + socket.connected);
    });
    socket.on("disconnect", (reason) => {
        console.log("disconnect : " + reason);
    });
    socket.on("join", (data) => {
        console.log('Somebody joined');
    });
    socket.on("leave", (data) => events.send(events_1.On.rcv_leave, data));
    socket.on("mouse", (data) => events.send(events_1.On.rcv_mouse, data));
    socket.on("error", (data) => {
        alert("An error occured on the server-side, you changes have not been persisted. Please try again later");
        console.error(data);
    });
    socket.on("new_text", (data) => {
        events.send(events_1.On.new_text, data);
    });
    socket.on("reset", (data) => {
        events.send(events_1.On.reset, {});
    });
    socket.on("reload", (data) => {
        events.send(events_1.On.reload, {});
    });
}
exports.default = SocketIOService;
